import { PairedCostAdjustments } from '@aloft/toolkit-shared';

import { Tkv2OrderContext } from '../../../../controller/types.js';
import {
  depreciatedCostAdjustmentsAfterMainDwelling,
  depreciatedCostAdjustmentsBeforeMainDwelling,
  marketAdjustments,
} from '../consts.js';
import { AdjustmentLabels } from '../types.js';
import { getLabel } from './getLabel.js';

export const makeAdjustmentLabelDictionary = (context: Tkv2OrderContext): AdjustmentLabels => {
  const standardLabels = Object.fromEntries(
    [
      ...marketAdjustments,
      ...depreciatedCostAdjustmentsBeforeMainDwelling,
      ...depreciatedCostAdjustmentsAfterMainDwelling,
    ].map(({ path }) => [path, getLabel(context, path as keyof PairedCostAdjustments)]),
  ) as AdjustmentLabels;

  const exceptionLabels: AdjustmentLabels = {
    site:
      context.pairedCostVersion === 'simplified_v1'
        ? 'Site Size'
        : {
            size: 'Site Size',
            location: 'Location',
            view: 'View',
          },
    mainDwelling: {
      gla: getLabel(context, 'mainDwelling' as keyof PairedCostAdjustments),
      propertyType: 'Property Type',
      sections: 'Sections',
      units: 'Units',
      foundation: 'Foundation',
    },
    locationView: {
      location: 'Location',
      view: 'View',
    },
  };

  return { ...standardLabels, ...exceptionLabels };
};
